import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const NoElements = ({ className, msgId = "common.nodata" }) => (
  <div className={className}>
    <FormattedMessage id={msgId} />
  </div>
);

NoElements.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Clave del mensaje, por defecto (common.noelements)
   */
  msgId: PropTypes.string,
};

export default NoElements;
